import { SurveyElement } from './element';

export class SocialMediaShareElement extends SurveyElement {}
